<div #heightProbe>
  @if ((breadcrumbs$ | async); as breadcrumbs) {
    @if (breadcrumbs.length > 1) {
      <nav class="mb-breadcrumb" aria-label="Breadcrumb">
        <ol class="mb-breadcrumb__list">
          @for (crumb of breadcrumbs; track crumb.url; let last = $last) {
            <li class="mb-breadcrumb__item" [class.mb-breadcrumb__item--current]="last">
              @if (!last) {
                <a class="mb-breadcrumb__link" [routerLink]="crumb.linkTree" [title]="crumb.label">{{ crumb.label }}</a>
                <span class="mb-breadcrumb__separator" aria-hidden="true">
                  <app-icon name="chevron-right"></app-icon>
                </span>
              } @else {
                <span class="mb-breadcrumb__current" aria-current="page" [title]="crumb.label">{{ crumb.label }}</span>
              }
            </li>
          }
        </ol>
      </nav>
    }
  }
</div>